var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedulerOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1910_16864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0C41.3137 0 44 2.68629 44 6V17.1553C43.9119 17.1471 43.8227 17.1426 43.7324 17.1426C42.1545 17.1426 40.875 18.422 40.875 20C40.875 21.578 42.1545 22.8574 43.7324 22.8574C43.8227 22.8574 43.9119 22.8519 44 22.8438V34C44 37.3137 41.3137 40 38 40H10C6.68629 40 4 37.3137 4 34V6C4 2.68629 6.68629 1.28851e-07 10 0H38Z",
    fill: "#04B7B1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7564 11.5337V12.5974C32.7564 13.1826 31.8673 13.1826 31.8673 12.5974C31.8673 12.01 31.391 11.5337 30.8036 11.5337H29.2387C28.7182 11.5337 28.2963 11.1118 28.2963 10.5912C28.2963 10.006 27.4071 10.006 27.4071 10.5912V12.5965C27.4071 13.1817 26.518 13.1817 26.518 12.5965C26.518 12.0091 26.0417 11.533 25.4543 11.5331L23.8886 11.5335C23.3681 11.5336 22.9461 11.1117 22.9461 10.5912C22.9461 10.006 22.057 10.006 22.057 10.5912V12.5965C22.057 13.1817 21.1679 13.1817 21.1679 12.5965C21.1679 12.0091 20.6916 11.533 20.1041 11.5331L18.5384 11.5335C18.0179 11.5336 17.5959 11.1117 17.5959 10.5912C17.5959 10.006 16.7068 10.006 16.7068 10.5912V12.5965C16.7068 13.1817 15.8177 13.1817 15.8177 12.5965C15.8177 12.0091 15.3327 11.4597 14.7568 11.576C14.4734 11.6333 14.2064 11.7575 13.9417 12.0222C13.6396 12.3243 13.4524 12.7404 13.4524 13.1971V28.0881C13.4524 29.0025 14.2022 29.7523 15.1167 29.7523H33.4573C34.3717 29.7523 35.1216 29.0025 35.1216 28.0881V13.198C35.1216 12.6841 34.8835 12.2194 34.5107 11.9126C34.0914 11.5675 33.6454 11.1343 33.6454 10.5913C33.6454 10.0061 32.7563 10.0061 32.7563 10.5913L32.7564 11.5337ZM27.3855 19.5649C29.0968 21.2762 29.0968 24.0494 27.3855 25.7608C24.6321 28.5133 19.907 26.5532 19.907 22.6629C19.907 18.7726 24.6321 16.8115 27.3855 19.5649ZM24.2876 17.3923C28.9675 17.3923 31.3256 23.0772 28.0142 26.3886C24.7018 29.701 19.0179 27.3428 19.0179 22.6629C19.0179 19.7523 21.3769 17.3923 24.2876 17.3923ZM26.2648 20.5173C26.6782 20.104 27.3077 20.7326 26.8934 21.146L23.2321 24.8082C23.0585 24.9819 22.7772 24.9819 22.6035 24.8082L21.254 23.4587C20.8406 23.0453 21.4693 22.4158 21.8826 22.8301C22.4541 23.4015 23.3806 23.4015 23.9521 22.8301L26.2648 20.5173ZM15.1176 15.5725C14.5324 15.5725 14.5324 14.6834 15.1176 14.6834H33.5388C34.124 14.6834 34.124 15.5725 33.5388 15.5725H15.1176Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1910_16864",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1910_16864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1910_16864",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulerOn);
export default __webpack_public_path__ + "static/media/SchedulerOn.ee8db88a68ee6ed911c4226010eb75e3.svg";
export { ForwardRef as ReactComponent };